import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CustomEncoder } from './custom-encoder';

@Injectable()
export class EncodeHttpParamsInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const params: HttpParams = new HttpParams({ encoder: new CustomEncoder(), fromString: req.params.toString() });
        return next.handle(req.clone({ params }));
    }
}
